import type { ReactNode } from "react";

export function Slides({ step, children }: { step: number; children: ReactNode[] }) {
  return (
    <div key={step} className="animate-in fade-in slide-in-from-right-4 duration-200">
      {children[step]}
    </div>
  );
}